import Image from 'next/image';

import styles from 'global/styles/StaticPages.module.scss';

import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import StaticPagesMenu from '../components/StaticPages/Menu';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'О Компании',
    href: '/o-kompanii',
  },
];

export default function About() {
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className={`${styles.staticPage} container`}>
        <StaticPagesMenu />
        <div className={styles.staticPageContent}>
          <h1 className={styles.staticPageTitle}>О компании</h1>
          <div className={styles.staticPageImage}>
            <Image src="/vb-company.png" alt="vobaza" fill />
          </div>
          <div className={styles.staticPageInfo}>
            <div className={styles.staticPageText}>
              <strong>В&nbsp;2020 </strong>году мир стал другим: ковидные ограничения, риски заражения, закрытые
              магазины и&nbsp;рынки&nbsp;&mdash; все это повлекло за&nbsp;собой неизбежный отток покупателей
              с&nbsp;фактических торговых площадок в&nbsp;онлайн магазины. Чтобы соответствовать духу времени, мы
              создали нашу платформу для быстрого выбора мебели любого назначения и&nbsp;размера.
              <br />
              <br />
              <strong>Наша основная цель</strong>: предложить мебель по&nbsp;доступной стоимости, удобной доставке
              и&nbsp;качественной сборке. Разработанная нами система умного поиска и&nbsp;фильтрации позволяет
              максимально сократить время на&nbsp;путь выбранного предмета в&nbsp;ваш дом. Оставив в&nbsp;прошлом
              огромные мебельные магазины, в&nbsp;которых покупатели проводили часы в&nbsp;попытке найти что-то
              подходящее, мы&nbsp;создали взамен удобный маркетплейс, где выбор совершается быстро, интуитивно понятно
              и&nbsp;современно.
              <br />
              <br />
              <strong>Каждый день</strong>
              &nbsp;мы&nbsp;улучшаем и&nbsp;обновляем нашу платформу, учитывая пожелания пользователей: расширяем
              ассортимент, совершенствуем инструменты поиска, добавляем услуги и&nbsp;работаем над сервисом. Время
              нельзя купить, но&nbsp;его можно сберечь!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
